import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { ProductMarquee } from "@/components/landing/ProductMarquee";
import { LabGrownPromo } from "@/components/landing/LabGrownPromo";
import { LooseStones } from "@/components/landing/LooseStones";
import { MerchandisingRails } from "@/components/landing/MerchandisingRails";
import { WeBuyGold } from "@/components/landing/WeBuyGold";
import { Showcase } from "@/components/landing/Showcase";
import { Services } from "@/components/landing/Services";
import { Heritage } from "@/components/landing/Heritage";
import { GuidesHub } from "@/components/landing/GuidesHub";
import { Locations } from "@/components/landing/Locations";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFab } from "@/components/landing/WhatsAppFab";
import { useSEO } from "@/lib/seo";

export default function Home() {
  const location = useLocation();
  useSEO({
    title: "Gold Time Jewelry | Fine Jewelry, Diamonds & Watches — Katy, TX",
    canonicalPath: "/",
    description:
      "Shop gold chains, diamond rings, name plates & lab-grown diamonds online. Family-owned Texas jeweler since 1991 with showrooms in Katy, Copperas Cove & Killeen. Insured US shipping.",
  });

  useEffect(() => {
    if (location.hash) {
      const timer = setTimeout(
        () => document.querySelector(location.hash)?.scrollIntoView({ behavior: "smooth" }),
        150
      );
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [location.key, location.hash]);

  return (
    <main data-testid="home-page">
      <Header />
      <Hero />
      <ProductMarquee />
      <LabGrownPromo />
      <LooseStones />
      <MerchandisingRails />
      <Services />
      <Showcase />
      <WeBuyGold />
      {/* Reviews section hidden until genuine Google reviews are connected (P2.2 owner decision) */}
      <GuidesHub />
      <Heritage />
      <Locations />
      <Contact />
      <Footer />
      <WhatsAppFab />
    </main>
  );
}
